import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Results from './pages/Results';
import LeadCapture from './pages/LeadCapture';
import Result from './pages/Result';
import ComoChegar from './pages/ComoChegar';
import Privacidade from './pages/Privacidade';
import MapaGps from './pages/MapaGps';
import Login from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Graves from './pages/admin/Graves';
import Deceased from './pages/admin/Deceased';
import Leads from './pages/admin/Leads';
import './styles/global.css';

function PublicLayout({ children }) {
  return (
    <div className="page-wrapper">
      <Header />
      <main className="page-main">{children}</main>
      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/resultados" element={<PublicLayout><Results /></PublicLayout>} />
        <Route path="/captura" element={<PublicLayout><LeadCapture /></PublicLayout>} />
        <Route path="/resultado" element={<PublicLayout><Result /></PublicLayout>} />
        <Route path="/como-chegar" element={<PublicLayout><ComoChegar /></PublicLayout>} />
        <Route path="/privacidade" element={<PublicLayout><Privacidade /></PublicLayout>} />
        <Route path="/mapa" element={<PublicLayout><MapaGps /></PublicLayout>} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="jazigos" element={<Graves />} />
          <Route path="sepultados" element={<Deceased />} />
          <Route path="leads" element={<Leads />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
